// Aug-2026 (user request) — standalone "Category Master" page in the sidebar
// Masters section (below Labour Library). GLOBAL Category 1 / Category 2
// masters shared by every Ops project (GRN lines, Labour Attendance, Labour
// Payments, PO Payment Requests). View needs project_grn.view; managing
// needs admin or project_grn.approve (same rule as the in-GRN modal).
import { useAuth } from "@/contexts/AuthContext";
import { Tags, ShieldAlert } from "lucide-react";
import { GrnCategoryMasterPanel } from "@/components/GrnCategoryMasterModal";

export default function CategoryMasterPage() {
  const { user, hasPerm } = useAuth();
  const canManage = user?.role === "admin" || hasPerm("project_grn", "approve");
  return (
    <div className="p-4 md:p-6 max-w-[900px]" data-testid="category-master-page">
      <div className="flex items-center gap-3 mb-1">
        <Tags size={22} className="text-[#F97316]" />
        <h1 className="text-xl font-bold text-slate-900">Category Master</h1>
      </div>
      <div className="text-xs text-slate-500 mb-4">
        Category 1 &amp; Category 2 — one global list used across ALL Ops projects (GRN lines, Labour Attendance, Labour Payments, PO Payment Requests).
      </div>
      {!canManage && (
        <div className="flex items-center gap-2 text-[11px] text-amber-800 bg-amber-50 border border-amber-300 rounded px-3 py-2 mb-3" data-testid="category-master-readonly-note">
          <ShieldAlert size={13} /> Read-only — adding or editing categories needs admin or the Project GRN Approve permission.
        </div>
      )}
      <GrnCategoryMasterPanel canManage={canManage} />
    </div>
  );
}
